// https://getbootstrap.com/docs/5.0/components/card/

import { is } from '@common/is/is'

import type { IBaseProps, IChildrenProps } from '../definitions'

interface IProps extends IBaseProps, IChildrenProps {}

/**
 * Egy BS Card komponens factory-ja.
 * @param props - JSX props {@link IProps}.
 */
export default function Card (props: IProps): HTMLElement {
  const { children, className = '', ...rest } = props

  const cn: readonly string[] = [
    'card',
    is.string(className) ? className : ''
  ]

  return <div className={ cn } { ...rest }>{ children }</div>
}
